<template>
  <textarea
    v-model="modelValue"
    data-slot="textarea"
    :class="cn(inputVariants(), 'min-h-16', props.class)"
  />
</template>

<script setup lang="ts">
import { useVModel } from "@vueuse/core";
import type { HTMLAttributes } from "vue";
import { inputVariants } from "@/components/ui/input";
import { cn } from "~/lib/utils";

const props = defineProps<{
  defaultValue?: string;
  modelValue?: string;
  class?: HTMLAttributes["class"];
}>();
const emits = defineEmits<{
  (e: "update:modelValue", payload: string): void;
}>();

const modelValue = useVModel(props, "modelValue", emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>
